<!-- <div class="LoginDiv" *ngIf="DataService.LoggedInUser.accessLevel == 0 && ShowRegister == false">
<label for="LoginEmail">Email:</label><input type="email" id="LoginEmail" name="LoginEmail" [(ngModel)]="LoginEmail" autocomplete="on" /><br />
<label for="LoginPassword">Password:</label><input type="password" id="LoginPassword" name="LoginPassword" [(ngModel)]="LoginPassword" /><br />
<button type="button" name="btnLogin" id="btnLogin" (click)="Login()">Login</button>
<button type="button" name="btnRegister" id="btnRegister" (click)="Register()">Register</button>
<button *ngIf="showRecover == true" type="button" name="btnRecover" id="btnRecover" (click)="RecoverPW(LoginEmail)">Recover Password</button><br />
<label class="Notes" [@reg]="state" id="Note">{{Note}}</label>
</div> -->

@if (DataService.LoggedInUser.accessLevel === 0 && !ShowRegister) {
  <div class="login-wrapper">
    <div class="login-card">
      <p class="subtitle">Sign in to continue</p>
      <div class="form-group">
        <label for="LoginEmail">Email</label>
        <input
          type="email"
          id="LoginEmail"
          name="LoginEmail"
          [(ngModel)]="LoginEmail"
          autocomplete="email"
          placeholder="you@example.com" />
      </div>
      <div class="form-group">
        <label for="LoginPassword">Password</label>
        <input
          type="password"
          id="LoginPassword"
          name="LoginPassword"
          [(ngModel)]="LoginPassword"
          placeholder="••••••••" />
      </div>
      <button class="btn primary" (click)="Login()">  Login </button>
      <div class="actions">
        <button class="btn link" (click)="Register()">Create account</button>
        @if (showRecover) {
          <button class="btn link" (click)="RecoverPW(LoginEmail)">  Forgot password? </button>
        }
      </div>
      @if (Note) {
        <div class="note" [@reg]="state">  {{ Note }} </div>
      }
    </div>
  </div>
}


@if (DataService.LoggedInUser.accessLevel > 0 && !ShowRegister) {
  <div class="profile-wrapper">
    <div class="profile-card">
      <!-- Header -->
      <div class="profile-header">
        <h2>User Details</h2>
        @if (DataService.MainStatus === 'UserMaintenance') {
          <select class="user-select"  [(ngModel)]="DataService.CurrentUser" (ngModelChange)="SaveChanges = false">
            @for (user of DataService.Players; track user) {
              <option [ngValue]="user"> {{ user.name }}</option>
            }
          </select>
        }
      </div>
      <!-- Form -->
      <div class="form-grid">
        <div class="form-field">
          <label>Name</label>
          <input [(ngModel)]="DataService.CurrentUser.name" (input)="SaveChanges = true" />
        </div>
        <div class="form-field">
          <label>Email</label>
          <input type="email" [(ngModel)]="DataService.CurrentUser.email" (input)="SaveChanges = true" />
        </div>
        <div class="form-field">
          <label>Phone</label>
          <input [(ngModel)]="DataService.CurrentUser.phone" (input)="SaveChanges = true" />
        </div>
        <div class="form-field">
          <label>Gender</label>
          <div class="radio-group">
            <label><input type="radio" value="M" [(ngModel)]="DataService.CurrentUser.gender"  (change)="SaveChanges = true" />Male</label>
            <label><input type="radio" value="F" [(ngModel)]="DataService.CurrentUser.gender" (change)="SaveChanges = true" />Female</label>
          </div>
        </div>
        <div class="form-field">
          <label>Country</label><input [(ngModel)]="DataService.CurrentUser.country" (input)="SaveChanges = true" />
        </div>
        <div class="form-field">
          <label>Province</label> <input [(ngModel)]="DataService.CurrentUser.province" (input)="SaveChanges = true" />
        </div>
        <div class="form-field">
          <label>Date of Birth</label><input matInput  [matDatepicker]="picker1"  [(ngModel)]="DataService.CurrentUser.dob"  (ngModelChange)="SaveChanges = true">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </div>
        <div class="form-field readonly">
          <label>Singles Points:</label> <span> {{ DataService.CurrentUser.singlesPoints }}</span>
        </div>
        <div class="form-field readonly">
          <label>Doubles Points:</label> <span> {{ DataService.CurrentUser.doublesPoints }}</span>
        </div>
        @if (DataService.LoggedInUser.accessLevel === 3  && DataService.MainStatus === 'UserMaintenance') {
          <div  class="form-field">
            <label>Access Level</label>
            <input type="number"  [(ngModel)]="DataService.CurrentUser.accessLevel"  (input)="SaveChanges = true" />
          </div>
        }
      </div>
      <!-- Grading -->
      @if (DataService.LoggedInUser.accessLevel > 1  && !DataService.CurrentUser.gradingReviewed && DataService.MainStatus === 'UserMaintenance') {
        <div class="grading-card" >
          <h3>Grading</h3>
          <div class="form-grid">
            @for (g of ['TableTennis','Badminton','Squash','Tennis']; track g) {
              <div class="form-field">
                <label>{{ g }}</label>
                <select [(ngModel)]="DataService.CurrentUser[g]" (change)="SaveChanges = true">
                  @for (grade of Grades; track grade) {
                    <option [value]="grade">{{ grade }}</option>
                  }
                </select>
              </div>
            }
          </div>
        </div>
      }
      <!-- Actions -->
      <div class="actions">
        @if (SaveChanges) {
          <button  class="btn primary"   (click)="SaveUserDetails(DataService.CurrentUser)">Save Changes</button>
        }
        @if (DataService.MainStatus !== 'UserMaintenance') {
          <button class="btn secondary" (click)="ChangePassword()">Change Password</button>
        }
        @if (DataService.MainStatus !== 'UserMaintenance') {
          <button class="btn secondary" (click)="Logout()"> Logout</button>
        }
        @if (DataService.LoggedInUser.accessLevel === 3 && DataService.MainStatus === 'UserMaintenance') {
          <button class="btn danger" (click)="deleteUser()"> Delete User</button>
        }
      </div>
      @if (!DataService.CurrentUser.gradingReviewed) {
        <div class="checkbox-row">
          <input type="checkbox"  [(ngModel)]="DataService.CurrentUser.gradingReviewed" (change)="SaveTheChanges()" />
          <span>Grading Reviewed</span>
        </div>
      }
      @if (Note) {
        <div class="note" [@reg]="state">
          {{ Note }}
        </div>
      }
    </div>
  </div>
}


<!-- <div class="PlayerDetails" *ngIf="DataService.LoggedInUser.accessLevel > 0 && ShowRegister == false">
<select *ngIf="DataService.MainStatus == 'UserMaintenance'" id="selUserMaintenance" name="selUserMaintenance"  [(ngModel)]="DataService.CurrentUser" (input)="SaveChanges = false">
  <option *ngFor="let user of DataService.Players" [ngValue]="user">
    {{user.name}}
  </option>
</select>
<label class="Heading">User Details</label>
<label for="Name">Name:</label><input id="Name" name="name" [(ngModel)]="DataService.CurrentUser.name" (input)="SaveChanges = true" /><br />
<label for="Email">Email:</label><input type="Email" id="Email" name="Email" [(ngModel)]="DataService.CurrentUser.email" (input)="SaveChanges = true" /><br />
<label for="Phone">Phone:</label><input id="Phone" name="Phone" [(ngModel)]="DataService.CurrentUser.phone" (input)="SaveChanges = true" /><br />
<div style="display:flex;">
  <label for="Male">Male</label><input id="Male" type="radio" value="M" [(ngModel)]="DataService.CurrentUser.gender" (input)="SaveChanges = true" />
  <label for="Female">Female</label><input id="Female" type="radio" value="F" [(ngModel)]="DataService.CurrentUser.gender" (input)="SaveChanges = true" /><br />
</div>
<label for="Country">Country:</label><input id="Country" name="Country" [(ngModel)]="DataService.CurrentUser.country" (input)="SaveChanges = true" /><br />
<label for="Province">Province:</label><input id="Province" name="Province" [(ngModel)]="DataService.CurrentUser.province" (input)="SaveChanges = true" /><br />
<div *ngIf="DataService.LoggedInUser.accessLevel == 3 && DataService.MainStatus == 'UserMaintenance'">
  <label for="AccessLevel">AccessLevel:</label><input id="AccessLevelUser" name="AccessLevel" [(ngModel)]="DataService.CurrentUser.accessLevel" (input)="SaveChanges = true" /><br />
</div>

<label for="DOB">Date Of Birth: </label><input id="DOBUser" matInput [matDatepicker]="picker1" [(ngModel)]="DataService.CurrentUser.dob" (ngModelChange)="SaveChanges = true" name="DOBUser">
<mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
<mat-datepicker #picker1 ></mat-datepicker><br /><br />

<label style="width: 260px;" for="SinglesPoints">Singles Points: {{DataService.CurrentUser.singlesPoints}}</label>
<label style="width: 260px;" for="DoublesPoints">Doubles Points: {{DataService.CurrentUser.doublesPoints}}</label><br /><br />
<div style="display: inline-block;" *ngIf="DataService.LoggedInUser.accessLevel > 1 && DataService.CurrentUser.GradingReviewed == false && DataService.MainStatus == 'UserMaintenance'">
  <h1>Grading:</h1><br>
  <div>
    <label for="TTGradeList">Table Tennis</label>
    <select id="TTGradeList" name="TTGradeList" [(ngModel)]="DataService.CurrentUser.TableTennis" *ngFor="let grade of Grades" (input)="SaveChanges = true"></select>
  </div>
  <div>
    <label for="BadGradeList">Badminton</label>
    <select id="BadGradeList" name="BadGradeList" [(ngModel)]="DataService.CurrentUser.Badminton" *ngFor="let grade of Grades" (input)="SaveChanges = true"> </select>
  </div>
  <div>
    <label for="SqGradeList">Squash</label>
    <select id="SqGradeList" name="SqGradeList" [(ngModel)]="DataService.CurrentUser.Squash" *ngFor="let grade of Grades" (input)="SaveChanges = true"> </select>
  </div>
  <div>
    <label for="TGradeList">Tennis</label>
    <select id="TGradeList" name="TGradeList" [(ngModel)]="DataService.CurrentUser.Tennis" *ngFor="let grade of Grades" (input)="SaveChanges = true"></select>
  </div>
</div><br /><br />
<button *ngIf="DataService.LoggedInUser.accessLevel == 3 && DataService.MainStatus == 'UserMaintenance'" type="button" id="btnDeleteUser" name="deleteUser" (click)="deleteUser()" style="margin-left: 100px">Delete {{DataService.CurrentUser.Name}}</button>
<div *ngIf="DataService.CurrentUser.GradingReviewed == false" style="display: flex;"><input type="checkbox" name="chkGradingReviewed" id="chkGradingReviewed" [(ngModel)]="DataService.CurrentUser.GradingReviewed" (input)="SaveTheChanges()" style="width: 12px; " /><label for="chkGradingReviewed" style="margin-top: 6px; font-size: 12px; width: auto;">Grading Reviewed</label></div>
<button *ngIf="DataService.MainStatus != 'UserMaintenance'" type="button" name="btnLogout" id="btnLogout" (click)="Logout()">Logout</button>
<button *ngIf="DataService.MainStatus != 'UserMaintenance'" type="button" name="btnChangePassword" id="btnChangePassword" (click)="ChangePassword()">Change Password</button>
<button type="button" *ngIf="SaveChanges == true" name="btnSaveChanges" id="btnSaveChanges" (click)="SaveUserDetails(DataService.CurrentUser)">Save Changes</button>
<label class="Notes" [@reg]="state" id="Note">{{Note}}</label>
</div> -->

@if (ShowRegister == true) {
  <div id="Register">
    @if (MainStatus != 'NewUser') {
      <div>
        <h2>Select from players in database, and register email & password</h2>
        <label>Choose Name:</label>
        <select id="PlayerList" name="PlayerList" [(ngModel)]="newUser" (input)="APlayerHasBeenSelected = true;PlayerSelected()">
          @for (player of DataService.Players | myfilter:filterPlayer; track player) {
            <option [ngValue]="player">
              {{player.name}}
            </option>
          }
        </select>
      </div>
    }
    @if (MainStatus == 'NewUser') {
      <h2>Create New Person</h2>
    }
    <div style="display: inline-block;"><label for="RegisterName">Name:</label><input id="RegisterName" name="name" [(ngModel)]="newUser.name" /><span class="redText">*</span></div>
    <div>
      <label for="Email">Email:</label><input id="RegisterEmail" name="Email" [(ngModel)]="newUser.email" />
    </div>
    <div>
      <label for="Phone">Phone:</label><input id="RegisterPhone" name="Phone" [(ngModel)]="newUser.phone" />
    </div>
    <div style="display: flex;">
      <label class="smaller" for="Male">Male</label><input class="smaller" id="RegisterMale" type="radio" value="M" [(ngModel)]="newUser.gender" />
      <label class="smaller" for="Female">Female</label><input class="smaller" id="RegisterFemale" type="radio" value="F" [(ngModel)]="newUser.gender" />
      <span class="redText">*</span>
    </div>
    <!--<label for="Gender">Gender:</label><input id="Gender" name="Gender" [(ngModel)]="Player.Gender" />-->
    <div>
      <label for="Country">Country:</label><input id="RegisterCountry" name="Country" [(ngModel)]="newUser.country" />
      <label for="Province">Province:</label><input id="RegisterProvince" name="Province" [(ngModel)]="newUser.province" />
    </div>
    <div>
      <label for="Password">Password:</label><input type="password" id="RegisterPassword" name="Password" [(ngModel)]="newUser.password" />
    </div>
    <div><label for="DOB">Date Of Birth: </label><input type="datetime-local" id="DOB" [(ngModel)]="newUser.DOB" name="DOB" /><br /></div>
    @if (APlayerHasBeenSelected == false) {
      <div style="display: contents;">
        <label>Grading:</label>
        <div>
          <label for="TTGradeList2">Table Tennis</label>
          @for (grade of Grades; track grade) {
            <select id="TTGradeList2" name="TTGradeList" [(ngModel)]="newUser.tableTennis"></select>
          }
        </div>
        <div>
          <label for="BadGradeList2">Badminton</label>@for (grade of Grades; track grade) {
          <select id="BadGradeList2" name="BadGradeList" [(ngModel)]="newUser.badminton"> </select>
        }
      </div>
      <div>
        <label for="SqGradeList2">Squash</label>@for (grade of Grades; track grade) {
        <select id="SqGradeList2" name="SqGradeList" [(ngModel)]="newUser.squash"> </select>
      }
    </div>
    <div>
      <label for="TGradeList2">Tennis</label>@for (grade of Grades; track grade) {
      <select id="TGradeList2" name="TGradeList" [(ngModel)]="newUser.Tennis"></select>
    }
  </div>
</div>
}
<button type="button" style="position: relative;" name="btnCancelNewUser" id="btnCancelNewUser" (click)="CancelRegister()">Cancel</button>
<button type="button" style="position: relative;" [disabled]="!newUser.name || !newUser.gender" name="btnSubmitNewUser" id="btnSubmitNewUser" (click)="RegisterUserDetails()">Submit new User</button>
<label style="width: auto; font-size: 14px;">If you want to login with this user then you will need to supply an email & password</label>
<label class="redText" style=" font-size: 14px;">* = required</label>
<label class="Notes" [@reg]="state" id="Note">{{Note}}</label>
</div>
}
